export default __webpack_public_path__ + "static/logo-green-5fe685665c0eaf7314a47559cb91a3f7.svg";